import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "tooltip-content"
};
const _hoisted_2 = {
  class: "tooltip-meta"
};
const _hoisted_3 = {
  class: "tooltip-time"
};
const _hoisted_4 = {
  class: "tooltip-title"
};
const _hoisted_5 = {
  key: 0,
  class: "tooltip-description"
};
const _hoisted_6 = {
  class: "tooltip-details"
};
const _hoisted_7 = {
  key: 0,
  class: "tooltip-detail"
};
const _hoisted_8 = {
  key: 1,
  class: "tooltip-detail"
};
const _hoisted_9 = {
  key: 2,
  class: "tooltip-detail"
};
const _hoisted_10 = {
  class: "tooltip-links"
};
const _hoisted_11 = {
  class: "tooltip-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [_createVNode(_Transition, {
    name: "tooltip"
  }, {
    default: _withCtx(() => [$props.visible && $props.event ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      ref: "tooltipRef",
      class: "event-tooltip",
      style: _normalizeStyle($setup.tooltipStyle)
    }, [_createElementVNode("div", {
      class: "tooltip-header",
      style: _normalizeStyle({
        backgroundColor: $setup.typeColor
      })
    }, null, 4), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
      class: "tooltip-type",
      style: _normalizeStyle({
        backgroundColor: $setup.typeColor,
        color: '#fff'
      })
    }, _toDisplayString($setup.typeLabel), 5), _createElementVNode("span", _hoisted_3, _toDisplayString($setup.formattedTime), 1)]), _createElementVNode("h4", _hoisted_4, _toDisplayString($props.event.title), 1), $props.event.description ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.event.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [$props.event.location ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    }), _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
    })], -1)), _createElementVNode("span", null, _toDisplayString($props.event.location), 1)])) : _createCommentVNode("", true), $props.event.attendees ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    })], -1)), _createElementVNode("span", null, _toDisplayString($props.event.attendees), 1)])) : _createCommentVNode("", true), $props.event.links?.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[5] || (_cache[5] = _createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    })], -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.event.links, link => {
      return _openBlock(), _createElementBlock("span", {
        key: link.type,
        class: "tooltip-link-tag"
      }, _toDisplayString($setup.linkLabel(link.type)), 1);
    }), 128))])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
      class: "tooltip-btn tooltip-btn--primary",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.handleEdit && $setup.handleEdit(...args))
    }, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    })], -1), _createTextVNode(" 编辑 ", -1)]))]), $props.event.type === 'task' ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      class: "tooltip-btn",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.handleComplete && $setup.handleComplete(...args))
    }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 13l4 4L19 7"
    })], -1), _createTextVNode(" 完成 ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("button", {
      class: "tooltip-btn tooltip-btn--danger",
      onClick: _cache[2] || (_cache[2] = (...args) => $setup.handleDelete && $setup.handleDelete(...args))
    }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
      class: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    })], -1), _createTextVNode(" 删除 ", -1)]))])])]), _createElementVNode("div", {
      class: "tooltip-arrow",
      style: _normalizeStyle({
        borderColor: `transparent transparent ${$setup.typeColor} transparent`
      })
    }, null, 4)], 4)) : _createCommentVNode("", true)]),
    _: 1
  })]);
}